class Util {
    constructor() {
        this.regExr = function(i18n, text) {
            return i18n.replace(/###/i, text);
        };

    }
}

export default new Util();